import { render } from "./Distribution.vue?vue&type=template&id=33abaa2c&ts=true"
import script from "./Distribution.vue?vue&type=script&lang=ts"
export * from "./Distribution.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-merchant-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__